import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getTemplateList } from 'components/template/TemplateAPI';
import { setTemplateList, setTemplateDashboardTemplateList } from 'store/slice/ManufSlice';
import TemplateDashboard from '../TemplateDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function TemplatePageImpl() {
    const dispatch = useDispatch();
    const { templateList} = useSelector((state)=>state.manufslice);
    
    const getTemplateListSuccess = (list) =>{dispatch(setTemplateList(list));}
    useEffect(() => {
        getTemplateList(()=>{}, getTemplateListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setTemplateDashboardTemplateList( templateList));
    },[ templateList])

    return (
        < TemplateDashboard />
    )

}